// types -> flag | auth | temp | cache | once | form

const KEY_APP_VERSION = 'flag-app-version';
const KEY_API_VERSION = 'flag-api-version';
const KEY_FORCE_UPDATE_VERSION = 'flag-force-update-version';
const KEY_PWA_QUESTION = 'flag-pwa-question';
const KEY_CREATION_TAG = 'auth-creation-tag';
const KEY_ACCESS_TOKEN = 'auth-access-token';
const KEY_ACTIVE_ROLE = 'once-active-role';
const KEY_REFRESH_TOKEN = 'auth-refresh-token';
const KEY_USER_HASH_ID = 'once-user-hash-id';
const KEY_PRODUCT_CREATE_LAST_CATEGORY_IDS = 'once-product-create-last-category-ids';
const KEY_LAST_PROFIT_PERCENT = 'once-last-profit-percent';
const KEY_HOW_IT_WORKS = 'once-how-it-works';
const KEY_HOW_IT_WORKS_FIRST = 'once-how-it-works-first';
const KEY_CART_PRODUCTS = 'temp-cart-products';
const KEY_LAST_CHECKOUT_INFO = 'temp-last-checkout-info';
const KEY_LAST_SENDER_INFO = 'once-last-sender-info';

export {
  KEY_APP_VERSION,
  KEY_API_VERSION,
  KEY_FORCE_UPDATE_VERSION,
  KEY_PWA_QUESTION,
  KEY_CREATION_TAG,
  KEY_ACCESS_TOKEN,
  KEY_ACTIVE_ROLE,
  KEY_REFRESH_TOKEN,
  KEY_USER_HASH_ID,
  KEY_PRODUCT_CREATE_LAST_CATEGORY_IDS,
  KEY_LAST_PROFIT_PERCENT,
  KEY_HOW_IT_WORKS,
  KEY_HOW_IT_WORKS_FIRST,
  KEY_CART_PRODUCTS,
  KEY_LAST_CHECKOUT_INFO,
  KEY_LAST_SENDER_INFO,
};
